module.exports = __webpack_public_path__ + "img/dlr.8891b109.png";